import api from '@/services/APIService';

/**
 * @typedef {Object} MembershipWaiverItem
 * @property {number} userId
 * @property {number} eventId
 * @property {number|null} organizationId
 * @property {string} organizationName
 * @property {number} membershipWaiverTemplateId
 * @property {string} membershipWaiverTitle
 * @property {0|1} required
 * @property {"Signed"|"NotSigned"|"Rejected"} waiverStatus
 * @property {number|null} signUserId
 * @property {string|null} signatoryName
 * @property {string|null} signatoryLastname
 * @property {string|null} signatoryEmail
 * @property {0|1} isMinor
 * @property {string} riderFirstName
 * @property {string} riderLastName
 * @property {number|null} waiverInstanceId
 * @property {string|null} waiverLink
 */
class MembershipWaiverService {
	getParticipantsWaivers(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers', data });
	}
	getMembershipWaiversList(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers/list', data });
	}
	generateByMembershipWaiverId(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers/generateByMembershipWaiverId', data });
	}
	getEligibleSignatories(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers/eligibleSignatories', data });
	}
	addAnotherSignatory(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers/addAnotherSignatory', data });
	}
	removeSignatory(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/waivers/removeSignatory', data });
	}
	resendWaiverEmail(data) {
		return api.fetch({ method: 'post', path: 'participant/waivers/sendWaiver', data });
	}
	updateWaiverSoleCustody(data) {
		return api.fetch({ method: 'post', path: '/participant/organization/waiver/soleCustody', data });
	}
}

export default new MembershipWaiverService();